import { unclampedLerp } from './unclamped-lerp';

/**
 * Linearly interpolates between the numbers.
 * The interpolation is done from `a` to `b`, so a `t` of 0 will return the value of `a`. A `t` of 1 will return the value of `b`.
 * Clamped, `t` values below 0 will return `a` and above 1 will return `b`
 *
 * @param a start value return when `t` is 0
 * @param b end value returned when `t` is 1
 * @param t denotes where the interpolated number should be placed between  `a` and  `b`
 * @returns the interpolated number
 */
export function lerp(a: number, b: number, t: number): number {
  if (t > 1) {
    return b;
  }
  if (t < 0) {
    return a;
  }
  return unclampedLerp(a, b, t);
}
